









import { Component, Prop, Vue } from 'vue-property-decorator'
import { ITUNES_GENRES } from '@/helpers/itunes'

@Component({})
export default class GenreSelect extends Vue {
  @Prop()
  value: number | null

  genres = ITUNES_GENRES

  emit(genreId: number) {
    this.$emit('input', genreId)
  }
}
